<template>
  <div class="">
    <div class="">
      <LeftCard />
    </div>
    <div class="w-full mt-6">
      <RightTable />
    </div>
  </div>
</template>
<script>
import LeftCard from "./LeftCard";
import RightTable from "./RightTable";
export default {
  components: {
    LeftCard,
    RightTable,
  },
};
</script>
